import { z } from 'zod';
import { NumericDisplayUnit } from 'libs/end-to-end/src/metrics';

/**
 * Available view modes for the TableView component
 */
export const ViewModeChart = [
  'table',
  'bar-chart',
  'pie-grid-chart',
  'line-chart',
  'grouped-bar-chart',
  'horizontal-bar-chart',
  'stacked-bar-chart',
  'heatmap',
] as const;

export const ViewModeChartZod = z.enum(ViewModeChart);
export type ViewMode = z.infer<typeof ViewModeChartZod>;

export const OverallDisplayModes = ['average', 'count'] as const;
export const OverallDisplayMode = z.enum(OverallDisplayModes);
export type OverallDisplayMode = z.infer<typeof OverallDisplayMode>;
export const DefaultOverallDisplayMode: OverallDisplayMode = 'average';

// As we add more props to view configuration for different custom viz, we will need to extend this schema.
export const ViewConfigurationSchema = z.object({
  // These properties apply to table view & heatmap.
  defaultViewMode: ViewModeChartZod.optional(),
  baseColors: z.string().array().optional(),
  hideSearch: z.boolean().optional(),
  displayBorder: z.boolean().optional(),
  selectedMetric: z.string().optional(),
  colorScheme: z.enum(['default', 'custom']).optional(),
  visibleDepartments: z.number().array().optional(),
  selectedFilterDefinition: z.string().optional(),
  units: NumericDisplayUnit.optional(),

  // These properties apply to table view, summary stats, & trends.
  // This field determines whether to show the average or the count in the overall summary section.
  overallDisplayMode: OverallDisplayMode.optional(),

  // This property allows you to store the appid of the streamlit app that you want to render over the custom viz view.
  streamlitPrototypeAppId: z.string().optional(),
});

export type ViewConfigurationSchema = z.infer<typeof ViewConfigurationSchema>;

export interface OverallDisplayModeFilterProps {
  viewConfiguration: ViewConfigurationSchema;
  setViewConfiguration?: (newValue: ViewConfigurationSchema) => void;
}
